'use client';
import { useLanguage } from '@/lib/i18n/LanguageContext';
import { HEALTHCARE_ROLES, type HealthcareRole } from '@/lib/specialties/types';

export function HealthcareRoleField({ value, onChange, error, required, disabled }: { value: HealthcareRole | null; onChange: (v: HealthcareRole) => void; error?: string; required?: boolean; disabled?: boolean }) {
  const { t } = useLanguage();
  return (
    <fieldset className="min-w-0">
      <legend className="block text-sm font-medium text-gray-700 mb-1">{t('profile.healthcareRole')}{required && <span className="text-red-500">*</span>}</legend>
      <div className="space-y-1.5">
        {HEALTHCARE_ROLES.map(r => (
          <label key={r} className={`flex items-start gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer ${value === r ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'} ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}>
            <input type="radio" name="healthcare_role" value={r} checked={value === r} disabled={disabled} onChange={() => onChange(r)} className="mt-0.5" />
            <span>{t(`profile.roleOptions.${r}`)}</span>
          </label>
        ))}
      </div>
      {error && <p className="mt-1 text-sm text-red-600" role="alert">{error}</p>}
    </fieldset>
  );
}
